import { Base } from '@studiometa/js-toolkit';
import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

/**
 * AboutAnimation class.
 * @extends Base
 * @class
 */
export default class AboutAnimation extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'AboutAnimation',
    refs: ['animationSplitChars[]', 'contentAbout[]'],
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    gsap.registerPlugin(SplitText);
    this.launchAnimation();
  }

  /**
   * Launch all animations with timeline
   * @returns {void}
   */
  launchAnimation() {
    const animateText = new SplitText(this.$refs.animationSplitChars, { type: 'chars' });
    const animationContentAbout = new SplitText(this.$refs.contentAbout, { type: 'lines' });
    const animationChars = animateText.chars;
    const animationLines = animationContentAbout.lines;

    const timeline = gsap.timeline();
    timeline.from(animationChars, {
      xPercent: -100,
      stagger: 0.03,
      opacity: 0,
      ease: 'power3.out',
      delay: 0.5,
    });
    timeline.from(
      animationLines,
      {
        yPercent: -20,
        stagger: 0.03,
        opacity: 0,
        duration: 1.2,
        ease: 'power3.out',
      },
      '-=0.8'
    );
  }
}
